import "./Button.scss";

const Button = ({
    variant = "filled",
    children,
    onClick,
    icon = null,
    animated = true,
    animationType = "lift", // "lift" o "pop"
    className = "",
    disabled = false,
}) => {
    const animationClass = animated ? `button--animated-${animationType}` : "";
    const disabledClass = disabled ? "button--disabled" : "";

    return (
        <button
            className={`button button--${variant} ${animationClass} ${disabledClass} ${className}`}
            onClick={onClick}
            disabled={disabled}
        >
            <span className="button__text">
                {children}
                {icon && <span className="button__icon">{icon}</span>}
            </span>
        </button>
    );
};

export default Button;
